import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import SpinnerCargando from "../SpinnerCargando";
import instanciaAxios from "../../../miscelaneo/instanciaAxios";
import { FaSearch } from "react-icons/fa";

const TablaEntidad = ({ setEntidadSeleccionada, descripcion, tipoEntidad }) => {
  const [filtro, setFiltro] = useState("");
  const [entidades, setEntidades] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const cargarDatos = async () => {
      let respuesta = {};
      try {
        setCargando(true);
        if (tipoEntidad) {
           respuesta = await instanciaAxios.get("/entidad/portipo/"+tipoEntidad);
          console.log('api response: '+JSON.stringify(respuesta))
        }else{
          respuesta = await instanciaAxios.get("/entidad/");
        }
        console.log(respuesta)
        if (respuesta.status === 200) {
          setEntidades(respuesta.data);
        } else {
          console.error("Datos inválidos o error en el formato recibido.");
          setEntidades([]); // Devolvemos un arreglo vacío en caso de error.
        }
      } catch (error) {
        console.error("Error al cargar los datos:", error);
        setEntidades([]); // En caso de error, arreglo vacío para evitar romper la tabla.
      } finally {
        setCargando(false);
      }
    };
  
    cargarDatos();
  }, []);

  const datosFiltrados = useMemo(() => {
    if (!filtro) return entidades;
    return entidades.filter(
      (entidad) =>
       entidad.id_entidad.toString().includes(filtro) || // Convertimos a string para buscar
       (entidad.nombre?.toLowerCase() || "").includes(filtro.toLowerCase()) ||
       (entidad.razon_social?.toLowerCase() || "").includes(filtro.toLowerCase()) ||
       (entidad.correo?.toLowerCase() || "").includes(filtro.toLowerCase()) ||
       (entidad.rnc?.toLowerCase() || "").includes(filtro.toLowerCase()) ||
       (entidad.cedula?.toLowerCase() || "").includes(filtro.toLowerCase())
    );
  }, [entidades, filtro]);

  const columns = [
    {
      name: "Nombre",
      selector: (row) => row.nombre + ' ' + (row.apellido ? row.apellido : ''),
      sortable: true,
    },
    {
        name: "Razón social",
        selector: (row) => row.razon_social,
        sortable: true,
    },
    {
        name: "Correo",
        selector: (row) => row.correo,
        sortable: true,
    },
    {
        name: "RNC",
        selector: (row) => row.rnc,
        sortable: true,
    },
    {
        name: "Cédula",
        selector: (row) => row.cedula,
        sortable: true,
    },
  ];

  const handleRowClick = (entidad) => {
    // Siempre devolver el objeto completo para consistencia
    setEntidadSeleccionada(entidad);
  };

  if (cargando) return <SpinnerCargando />;
if (entidades.length === 0) {
  return (
    <div className="text-center text-gray-500 mt-5">
      No se encontraron entidades.
    </div>
  );
}

  return (
    <DataTable
      title={
        <>
          <h2 className="text-xl font-semibold text-center font-cascadia text-black">
            Entidades
          </h2>
          <p className="text-sm text-gray-500 text-center">
            {descripcion ? descripcion : null}
          </p>
        </>
      }
      columns={columns}
      data={datosFiltrados}
      pagination
      highlightOnHover
      onRowClicked={handleRowClick}
      dense
      subHeader
      subHeaderComponent={
        <div className="w-full relative">
          <FaSearch className="absolute right-3 top-1/2 transform -translate-y-1/2 text-color-secundario" />
          <input
            type="text"
            placeholder="Buscar..."
            className="w-full border px-3 py-1 rounded-xl"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
        </div>
      }
    />
  );
};

export default TablaEntidad;
